<template>
  <section class="sidebar-container">
    <div class="logolayer">
      <i id="logoicon" class="fa-solid fa-bars-staggered"></i>
      <img
        id="ipalogo"
        :src="currentLogo"
        alt="IPromiseAfrica"
        decoding="async"
        @click="toggleTheme"
      />
    </div>

    <div id="welcome">
      <div id="userimage" class="user-avatar-placeholder" aria-hidden="true">
        <i class="fa-solid fa-user"></i>
      </div>
      <div class="welcome-text">
        <p id="welcome-note">Welcome</p>
        <h1>Anderson Silva</h1>
      </div>
    </div>

    <!-- NAVIGATION CONTAINER (Scrollable) -->
    <div class="nav-container">
      <!-- DASHBOARD SECTION -->
      <div class="section-header" @click="toggleSection('dashboard')">
        <span class="section-title">Dashboard</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.dashboard }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.dashboard }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'OverView')"
          :class="{ active: activeSection === 'OverView' }"
        >
          <i class="fa-solid fa-chart-line"></i>
          <p class="item-text">Overview</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'SalesData')"
          :class="{ active: activeSection === 'SalesData' }"
        >
          <i class="fa-solid fa-chart-column"></i>
          <p class="item-text">Sales Analytics</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'TeamMembers')"
          :class="{ active: activeSection === 'TeamMembers' }"
        >
          <i class="fa-solid fa-people-group"></i>
          <p class="item-text">Team Members</p>
        </div>
      </div>

      <!-- PRODUCTS SECTION -->
      <div class="section-header" @click="toggleSection('products')">
        <span class="section-title">Products</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.products }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.products }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'ProDucts')"
          :class="{ active: activeSection === 'ProDucts' }"
        >
          <i class="fa-solid fa-cubes"></i>
          <p class="item-text">All Products</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'AdminCart')"
          :class="{ active: activeSection === 'AdminCart' }"
        >
          <i class="fa-solid fa-cart-shopping"></i>
          <p class="item-text">Product Carts</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'CreateProduct')"
          :class="{ active: activeSection === 'CreateProduct' }"
        >
          <i class="fa-solid fa-square-plus"></i>
          <p class="item-text">Create Product</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'CreateParalympicEquipment')"
          :class="{ active: activeSection === 'CreateParalympicEquipment' }"
        >
          <i class="fa-solid fa-wheelchair"></i>
          <p class="item-text">Paralympic Equipment</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'CreateKidsProduct')"
          :class="{ active: activeSection === 'CreateKidsProduct' }"
        >
          <i class="fa-solid fa-child-reaching"></i>
          <p class="item-text">Kids Product</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'KidsStoreOrders')"
          :class="{ active: activeSection === 'KidsStoreOrders' }"
        >
          <i class="fa-solid fa-child-reaching"></i>
          <p class="item-text">Kids Store Orders</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'CustomerOrders')"
          :class="{ active: activeSection === 'CustomerOrders' }"
        >
          <i class="fa-solid fa-truck-fast"></i>
          <p class="item-text">Product Orders</p>
        </div>
      </div>

      <!-- CUSTOMERS SECTION -->
      <div class="section-header" @click="toggleSection('customers')">
        <span class="section-title">Customers</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.customers }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.customers }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'UserManagement')"
          :class="{ active: activeSection === 'UserManagement' }"
        >
          <i class="fa-solid fa-user-group"></i>
          <p class="item-text">Customer List</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'ReviewManagement')"
          :class="{ active: activeSection === 'ReviewManagement' }"
        >
          <i class="fa-solid fa-star-half-stroke"></i>
          <p class="item-text">Product Reviews</p>
        </div>

        <div
          v-if="hasCustomerTicketsAccess"
          class="dashboardlist"
          @click="$emit('change-view', 'AdminSupport')"
          :class="{ active: activeSection === 'AdminSupport' }"
        >
          <i class="fa-solid fa-life-ring"></i>
          <p class="item-text">Customer tickets</p>
        </div>
      </div>
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'AdminDiscountManager')"
          :class="{ active: activeSection === 'AdminDiscountManager' }"
        >
          <i class="fa-solid fa-clipboard-list"></i>
          <p class="item-text">Issue Discounts</p>
        </div>

      <!-- SELLERS SECTION -->
      <div class="section-header" @click="toggleSection('sellers')">
        <span class="section-title">Sellers</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.sellers }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.sellers }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'SellerManagement')"
          :class="{ active: activeSection === 'SellerManagement' }"
        >
          <i class="fa-solid fa-user-tie"></i>
          <p class="item-text">Seller List</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'AdminProductListings')"
          :class="{ active: activeSection === 'AdminProductListings' }"
        >
          <i class="fa-solid fa-clipboard-list"></i>
          <p class="item-text">Seller Listings</p>
        </div>

        <div
          class="dashboardlist"
          @click="$emit('change-view', 'AdminSellerReviews')"
          :class="{ active: activeSection === 'AdminSellerReviews' }"
        >
          <i class="fa-solid fa-comment-dots"></i>
          <p class="item-text">Seller Reviews</p>
        </div>
      </div>

      <!-- PITCHES SECTION -->
      <div class="section-header" @click="toggleSection('pitches')">
        <span class="section-title">Pitches</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.pitches }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.pitches }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'AdminPitchesView')"
          :class="{ active: activeSection === 'AdminPitchesView' }"
        >
          <i class="fa-solid fa-location-dot"></i>
          <p class="item-text">Pitch Management</p>
        </div>
      </div>

      <!-- ADMINISTRATION SECTION -->
      <div class="section-header" @click="toggleSection('administration')">
        <span class="section-title">Administration</span>
        <i class="fa-solid fa-chevron-right section-toggle" :class="{ rotated: expandedSections.administration }"></i>
      </div>
      <div class="section-items" :class="{ collapsed: !expandedSections.administration }">
        <div
          class="dashboardlist"
          @click="$emit('change-view', 'UserRoleAssignment')"
          :class="{ active: activeSection === 'UserRoleAssignment' }"
        >
          <i class="fa-solid fa-user-shield"></i>
          <p class="item-text">Role Management</p>
        </div>

        <div class="dashboardlist">
          <i class="fa-solid fa-sliders"></i>
          <p class="item-text">Settings</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useAdminAuthStore } from "../../authen/adminAuth";

export default {
  name: "OffCanvas",
  props: ["activeSection"],
  data() {
    return {
      isDarkMode: window.matchMedia("(prefers-color-scheme: dark)").matches,
      expandedSections: {
        dashboard: true,
        products: true,
        customers: true,
        sellers: true,
        pitches: true,
        administration: true
      },
      isCollapsed: false
    };
  },
  computed: {
    currentLogo() {
      return this.isDarkMode
        ? require("../../assets/ipalogo_dark.png")
        : require("../../assets/ipalogo.png");
    },
    /** Same rule as backend: super_admin or support only */
    hasCustomerTicketsAccess() {
      const store = useAdminAuthStore();
      store.checkToken();
      return store.canAccessSupportAdminTools;
    },
  },
  mounted() {
    // Watch for system theme changes dynamically
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        this.isDarkMode = e.matches;
      });
    
    // Check screen size for initial collapse state
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle("dark-theme", this.isDarkMode);
    },
    
    toggleSection(section) {
      this.expandedSections[section] = !this.expandedSections[section];
    },
    
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('toggle-collapse', this.isCollapsed);
    },
    
    checkScreenSize() {
      // Collapse text on medium screens, show icons only on small screens
      if (window.innerWidth <= 842) {
        this.isCollapsed = true;
      } else {
        this.isCollapsed = false;
      }
    }
  },
};
</script>

<style scoped>
.sidebar-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  color: var(--text-color1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--background-color2);
  border-right: 1px solid var(--background-color3);
  overflow: hidden;
}

.logolayer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  animation: slideDown 0.4s ease-out;
}

#ipalogo {
  width: 60px;
  height: 60px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

#ipalogo:hover {
  transform: rotate(10deg) scale(1.05);
  filter: brightness(1.2);
}

#logoicon {
  font-size: 1rem;
  color: var(--text-color2);
  cursor: pointer;
  transition: color 0.3s;
}

#logoicon:hover {
  color: var(--border-color-hover);
}

#welcome {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  margin: 0.5rem 0;
  border-radius: 10px;
  background: var(--background-color1);
  animation: fadeIn 0.5s ease-out 0.1s both;
}

#userimage {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  object-fit: cover;
  border: 2px solid var(--background-color3);
  transition: transform 0.3s, border-color 0.3s;
}

.user-avatar-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--background-color3);
  color: var(--text-color2);
  font-size: 1.1rem;
}

#userimage:hover {
  transform: scale(1.05);
  border-color: var(--border-color-hover);
}

.welcome-text {
  flex: 1;
}

#welcome-note {
  font-size: 0.7rem;
  margin: 0;
  color: var(--text-color2);
  opacity: 0.8;
  animation: fadeIn 0.5s ease-out 0.2s both;
}

.welcome-text h1 {
  font-size: 0.9rem;
  margin: 0.2rem 0 0 0;
  color: var(--text-color1);
  font-weight: 600;
  animation: fadeIn 0.5s ease-out 0.3s both;
}

/* Navigation Container - Scrollable */
.nav-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.3rem;
  margin-top: 0.5rem;
}

.nav-container::-webkit-scrollbar {
  width: 4px;
}

.nav-container::-webkit-scrollbar-track {
  background: var(--background-color1);
  border-radius: 10px;
}

.nav-container::-webkit-scrollbar-thumb {
  background: var(--border-color-hover);
  border-radius: 10px;
}

.nav-container::-webkit-scrollbar-thumb:hover {
  background: var(--border-color-hover3);
}

/* Section Headers */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 0.8rem;
  margin: 0.8rem 0 0.3rem 0;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  animation: slideInLeft 0.4s ease-out both;
}

.section-header:hover {
  background: var(--background-color1);
}

.section-header:nth-child(1) { animation-delay: 0.1s; }
.section-header:nth-child(3) { animation-delay: 0.15s; }
.section-header:nth-child(5) { animation-delay: 0.2s; }
.section-header:nth-child(7) { animation-delay: 0.25s; }
.section-header:nth-child(9) { animation-delay: 0.3s; }
.section-header:nth-child(11) { animation-delay: 0.35s; }

.section-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-color2);
  opacity: 0.8;
  transition: color 0.3s;
}

.section-header:hover .section-title {
  color: var(--border-color-hover);
  opacity: 1;
}

.section-toggle {
  font-size: 0.7rem;
  color: var(--text-color2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.section-toggle.rotated {
  transform: rotate(90deg);
  color: var(--border-color-hover);
}

/* Section Items */
.section-items {
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeIn 0.3s ease-out;
}

.section-items.collapsed {
  max-height: 0 !important;
  opacity: 0;
  transform: translateY(-10px);
}

/* Dashboard Items */
.dashboardlist {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.8rem;
  margin: 0.2rem 0;
  border-left: 3px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.3s ease-out both;
}

.dashboardlist:nth-child(1) { animation-delay: 0.1s; }
.dashboardlist:nth-child(2) { animation-delay: 0.15s; }
.dashboardlist:nth-child(3) { animation-delay: 0.2s; }
.dashboardlist:nth-child(4) { animation-delay: 0.25s; }

.dashboardlist:hover {
  background: var(--background-color1);
  transform: translateX(5px);
  border-left-color: var(--border-color-hover1);
}

.dashboardlist.active {
  background: var(--background-color1);
  border-left-color: var(--border-color-hover);
  box-shadow: 0 2px 8px var(--box-shadow);
}

.dashboardlist.active:hover {
  border-left-color: var(--border-color-hover3);
}

.dashboardlist i {
  font-size: 0.85rem;
  margin-right: 0.8rem;
  color: var(--text-color2);
  transition: all 0.3s ease;
  min-width: 20px;
  text-align: center;
}

.dashboardlist:hover i,
.dashboardlist.active i {
  color: var(--border-color-hover);
  transform: scale(1.1);
}

.item-text {
  font-size: 0.8rem;
  margin: 0;
  color: var(--text-color1);
  transition: color 0.3s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboardlist:hover .item-text {
  color: var(--border-color-hover);
}

.dashboardlist.active .item-text {
  color: var(--border-color-hover);
  font-weight: 500;
}

/* Responsive Styles */

/* Large tablets and small desktops (1024px and below) */
@media (max-width: 1024px) {
  .sidebar-container {
    width: 200px;
  }
  
  .item-text {
    font-size: 0.75rem;
  }
  
  .dashboardlist {
    padding: 0.5rem 0.6rem;
  }
  
  .section-header {
    padding: 0.5rem 0.6rem;
  }
  
  .section-title {
    font-size: 0.7rem;
  }
  
  #ipalogo {
    width: 55px;
    height: 55px;
  }
  
  #userimage {
    width: 40px;
    height: 40px;
  }
}

/* Medium tablets (900px and below) */
@media (max-width: 900px) {
  .sidebar-container {
    width: 70px;
    padding: 0.5rem 0.3rem;
  }
  
  .logolayer {
    justify-content: center;
    padding: 0.3rem;
  }
  
  #ipalogo {
    width: 45px;
    height: 45px;
  }
  
  #logoicon {
    display: none;
  }
  
  #welcome {
    flex-direction: column;
    padding: 0.5rem;
    text-align: center;
  }
  
  #userimage {
    width: 35px;
    height: 35px;
    margin-bottom: 0.3rem;
  }
  
  .welcome-text {
    display: none;
  }
  
  .section-header {
    justify-content: center;
    padding: 0.5rem 0.2rem;
    margin: 0.5rem 0 0.2rem 0;
  }
  
  .section-title {
    display: none;
  }
  
  .section-toggle {
    display: none;
  }
  
  .dashboardlist {
    justify-content: center;
    padding: 0.6rem 0.2rem;
    border-left: none;
    border-radius: 8px;
  }
  
  .dashboardlist:hover {
    transform: translateY(-2px);
    background: var(--background-color1);
  }
  
  .dashboardlist.active {
    border-left: none;
    background: var(--border-color-hover1);
  }
  
  .item-text {
    display: none;
  }
  
  .dashboardlist i {
    margin-right: 0;
    font-size: 1.1rem;
  }
  
  .section-items {
    text-align: center;
  }
}

/* Tablets (768px and below) */
@media (max-width: 768px) {
  .sidebar-container {
    width: 70px;
    padding: 0.5rem 0.25rem;
  }
  
  #ipalogo {
    width: 42px;
    height: 42px;
  }
  
  #userimage {
    width: 32px;
    height: 32px;
  }
  
  .dashboardlist {
    padding: 0.55rem 0.15rem;
  }
  
  .dashboardlist i {
    font-size: 1.05rem;
  }
  
  .section-header {
    padding: 0.45rem 0.15rem;
  }
}

/* Mobile phones (640px and below) */
@media (max-width: 640px) {
  .sidebar-container {
    width: 65px;
    padding: 0.5rem 0.2rem;
  }
  
  .logolayer {
    padding: 0.25rem;
  }
  
  #ipalogo {
    width: 40px;
    height: 40px;
  }
  
  #welcome {
    padding: 0.4rem;
  }
  
  #userimage {
    width: 30px;
    height: 30px;
  }
  
  .dashboardlist {
    padding: 0.5rem 0.1rem;
    margin: 0.15rem 0;
  }
  
  .dashboardlist i {
    font-size: 1rem;
  }
  
  .section-header {
    padding: 0.4rem 0.1rem;
    margin: 0.4rem 0 0.15rem 0;
  }
  
  .nav-container {
    padding-right: 0.2rem;
  }
}

/* Small mobile phones (480px and below) */
@media (max-width: 480px) {
  .sidebar-container {
    width: 60px;
    padding: 0.5rem 0.15rem;
  }
  
  #ipalogo {
    width: 38px;
    height: 38px;
  }
  
  #welcome {
    padding: 0.35rem;
  }
  
  #userimage {
    width: 28px;
    height: 28px;
  }
  
  .dashboardlist {
    padding: 0.5rem 0.1rem;
  }
  
  .dashboardlist i {
    font-size: 0.95rem;
  }
  
  .section-header {
    padding: 0.35rem 0.1rem;
  }
  
  .nav-container {
    padding-right: 0.15rem;
  }
}

/* Extra small phones (360px and below) */
@media (max-width: 360px) {
  .sidebar-container {
    width: 55px;
    padding: 0.4rem 0.1rem;
  }
  
  #ipalogo {
    width: 35px;
    height: 35px;
  }
  
  #welcome {
    padding: 0.3rem;
  }
  
  #userimage {
    width: 26px;
    height: 26px;
  }
  
  .dashboardlist {
    padding: 0.45rem 0.05rem;
  }
  
  .dashboardlist i {
    font-size: 0.9rem;
  }
  
  .section-header {
    padding: 0.3rem 0.05rem;
  }
}

/* Mobile expanded state (when sidebar is opened on mobile) */
@media (max-width: 768px) {
  .sidebar-container.mobile-expanded {
    width: 250px !important;
  }
  
  .sidebar-container.mobile-expanded .item-text,
  .sidebar-container.mobile-expanded .section-title,
  .sidebar-container.mobile-expanded .section-toggle,
  .sidebar-container.mobile-expanded .welcome-text {
    display: block !important;
  }
  
  .sidebar-container.mobile-expanded .dashboardlist {
    justify-content: flex-start;
    padding: 0.6rem 0.8rem;
    border-left: 3px solid transparent;
  }
  
  .sidebar-container.mobile-expanded .dashboardlist i {
    margin-right: 0.8rem;
  }
  
  .sidebar-container.mobile-expanded .section-header {
    justify-content: space-between;
    padding: 0.6rem 0.8rem;
  }
  
  .sidebar-container.mobile-expanded #welcome {
    flex-direction: row;
    text-align: left;
  }
  
  .sidebar-container.mobile-expanded .logolayer {
    justify-content: space-between;
  }
  
  .sidebar-container.mobile-expanded #logoicon {
    display: block;
  }
}

/* Landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .sidebar-container {
    padding: 0.3rem 0.2rem;
  }
  
  .logolayer {
    padding: 0.2rem;
    margin-bottom: 0.3rem;
  }
  
  #ipalogo {
    width: 35px;
    height: 35px;
  }
  
  #welcome {
    padding: 0.3rem;
    margin: 0.3rem 0;
  }
  
  #userimage {
    width: 28px;
    height: 28px;
  }
  
  .section-header {
    padding: 0.4rem 0.2rem;
    margin: 0.3rem 0 0.2rem 0;
  }
  
  .dashboardlist {
    padding: 0.4rem 0.2rem;
    margin: 0.15rem 0;
  }
  
  .nav-container {
    margin-top: 0.3rem;
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  .dashboardlist,
  .section-header {
    min-height: 44px; /* Minimum touch target size */
  }
  
  .dashboardlist {
    padding: 0.75rem 0.8rem;
  }
  
  .section-header {
    padding: 0.75rem 0.8rem;
  }
  
  /* Larger touch targets on mobile */
  @media (max-width: 640px) {
    .dashboardlist {
      min-height: 48px;
      padding: 0.7rem 0.2rem;
    }
    
    .section-header {
      min-height: 48px;
      padding: 0.7rem 0.2rem;
    }
  }
  
  /* Active state feedback */
  .dashboardlist:active {
    transform: scale(0.95);
    background: var(--background-color1);
  }
  
  .section-header:active {
    background: var(--background-color1);
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .sidebar-container {
    border-right-width: 0.5px;
  }
  
  .section-header {
    border-bottom-width: 0.5px;
  }
}

/* Print styles */
@media print {
  .sidebar-container {
    display: none;
  }
}

/* Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Hover effect for collapsed state */
@media (min-width: 843px) {
  .sidebar-container:hover {
    box-shadow: 5px 0 20px rgba(0, 0, 0, 0.1);
  }
}
</style>